export default __webpack_public_path__ + "static/media/Raider's Mask of the Covert Trail.f52e5ded.jpg";